import { createLoadingScreen } from "../DomUtilities/ElementsCreator";
import openErrorModal from "../Error/ErrorModal";
import User from "../Models/User";
import Roles from "../Constants/Roles";
import { openBackendValidationErrorModal } from "../Error/ErrorUtilities";

export default class UserBaseModal {
	createUserBtn: HTMLButtonElement;
	loadingScreen: HTMLElement;

	constructor(createUserButton: HTMLButtonElement) {
		this.createUserBtn = createUserButton;
		this.loadingScreen = createLoadingScreen();
	}

	protected getModalData(form: HTMLFormElement): { valid: boolean, data: User } {

		const inputs = form.elements;
		let data: User = new User();
		let valid: boolean = form.checkValidity();
		const props: Array<string> = Object.keys(data);

		for (let i = 0; i < props.length; i++) {
			let input = (inputs[i] as HTMLInputElement);
			if (input) {
				if (props[i] === "roles") {
					data[props[i]].push(input.value);
				} else {
					data[props[i]] = input.value;
				}
			}
		}

		if (valid && !data.storeId) {
			delete data.storeId;
		}

		return { valid, data };
	}

	protected addPhonenumberValidationMsg(modalDiv: HTMLDivElement) {
		const phonenumberInput: HTMLInputElement = modalDiv.querySelector("input[name='phonenumber']");
		let errorMsg = phonenumberInput.dataset.errorMsg;

		phonenumberInput.oninput = () => {
			if (/^[0-9]{8}$/.test(phonenumberInput.value)) {
				phonenumberInput.setCustomValidity("");
			} else {
				phonenumberInput.setCustomValidity(errorMsg);
			}
		}
	}

	protected openErrorMsgModal(err: { body: string, status: number }) {
		if (err.status == 500 && err.body.toLowerCase().includes("phonenumber")) {
			let phoneErrorMsg = this.createUserBtn.dataset.duplicatePhoneError;
			openErrorModal(phoneErrorMsg, null, null, "30%", "210px");
		} else if (err.status == 500 && err.body.toLowerCase().includes("email") || err.body.toLowerCase().includes("username")) {
			let emailErrorMsg = this.createUserBtn.dataset.duplicateEmailError;
			openErrorModal(emailErrorMsg, null, null, "30%", "210px");
		} else {
			openBackendValidationErrorModal(err);
		}
	}
}
